export enum GeneralRoutesEnum {
    GENERAL_TERMS = '/general/terms',
}

export enum ProductRoutesEnum {
    PRODUCT_CREATE = '/product/create',
    PRODUCT_GET_ALL_ORGANISATION_PRODUCTS = '/product/get-all',
    PRODUCT_GET_ALL_BY_CATEGORY = '/product/get-all-by-category',
    PRODUCT_UPDATE = '/product/update',
    PRODUCT_SUPPLY = '/product/supply',
    PRODUCT_DELETE = '/product/delete',
    PRODUCT_SEARCH = '/product/search',
}

export enum CategoryRoutesEnum {
    CATEGORY_CREATE = '/category/create',
    CATEGORY_GET_ALL_ORGANISATION_CATEGORIES = '/category/get-all',
    CATEGORY_UPDATE = '/category/update',
    CATEGORY_DELETE = '/category/delete',
}

export enum OrganisationRoutesEnum {
    ORGANISATION_UPDATE = '/organisation/update',
}

export enum UserRoutesEnum {
    USER_CREATE = '/user/create',
    USER_LOGIN = '/user/login',
    USER_CREATE_USER_PASSWORD = '/user/create-user-password',
    USER_UPDATE_USER_PASSWORD = '/user/update-user-password',
    USER_UPDATE_USER = '/user/update-user',
    USER_VERIFY_EMAIL = '/user/verify-email',
    USER_RESEND_OTP = '/user/resend-otp',
    USER_GET_ALL_BY_ORG_ID = "/user/get-all-collab",
    USER_FORGOT_PASSWORD = '/user/forgot-password'
}

export enum PathsEnum {
    SEND_MESSAGE = "/bm-send-message",
    INIT_CHAT = "/bm-init-chat"
}

export enum BasketRoutesEnum {
    BASKET_SET_BASKET = '/basket/set-basket',
    BASKET_GET_COLLAB_BASKET = '/basket/get-collab-basket',
    BASKET_DELETE = '/basket/delete',
}

export enum SaleRoutesEnum {
    SALE_CREATE = '/sale/create',
    SALE_GET_ALL = '/sale/get-all',
    SALE_RETURN_PRODUCT = '/sale/return-product'
}

export enum ClientRoutesEnum {
    CLIENT_CREATE = '/client/create',
    CLIENT_GET_ALL = '/client/get-all',
    CLIENT_FIND = '/client/find',
    CLIENT_UPDATE = '/client/update',
    CLIENT_DELETE = '/client/delete',
}

export enum DashboardRoutesEnum {
    DASHBOARD_GET_YEAR_SALES_BY_MONTH = '/dashboard/get-year-sales-by-month',
    DASHBOARD_GET_MONTH_SALES_BY_WEEK = '/dashboard/get-month-sales-by-week',
    DASHBOARD_GET_WEEK_SALES_BY_DAY = '/dashboard/get-week-sales-by-day',
    DASHBOARD_GET_TODAY_SALES_BY_HOUR = '/dashboard/get-today-sales-by-hour',
    DASHBOARD_GET_TOP_PRODUCTS_STATS = '/dashboard/get-top-products-stats',
    DASHBOARD_GET_AVERAGE_SALES_BY_HOUR = '/dashboard/get-average-sales-by-hour',
    DASHBOARD_GET_AVERAGE_SALES_BY_DAY_OF_WEEK = '/dashboard/get-average-sales-by-day-of-week',
    DASHBOARD_GET_SELLER_PERFORMANCE = '/dashboard/get-seller-performance',
    DASHBOARD_GET_ORGANISATION_MONTHLY_REVENUE_AND_NEXT_INVOICE_DATE = '/dashboard/get-organisation-monthly-revenue-and-next-invoice-date',
}

export enum AssistantRoutesEnum {
    ASSISTANT_GET_ASSISTANTS = '/assistant/get-assistants',
    ASSISTANT_SET_ASSISTANT = '/assistant/set-assistant',
    ASSISTANT_CHAT_BOT_INIT_CHAT = '/assistant/init-chat',
    ASSISTANT_CHAT_BOT_SEND_MESSAGE = '/assistant/send-message',
}

export enum InventoryRoutesEnum {
    INVENTORY_NEW = '/inventory/new',
    INVENTORY_GET_ALL = '/inventory/get-all',
}

export enum CreditRoutesEnum {
    CREDIT_PAYMENT = '/credit/payment',
    CREDIT_GET_ALL = '/credit/get-all',
    CREDIT_GET_CLOSED = '/credit/get-closed',
}

export enum PromotionRoutesEnum {
    PROMOTION_CREATE = '/promotion/create',
    PROMOTION_GET_ALL_ORGANISATION_PROMOTIONS = '/promotion/get-all',
    PROMOTION_GET_ONE = '/promotion/get-one',
    PROMOTION_UPDATE = '/promotion/update',
    PROMOTION_ADD_TO_CATEGORY = '/promotion/add-to-category',
    PROMOTION_ADD_TO_PRODUCT = '/promotion/add-to-product',
    PROMOTION_DELETE = '/promotion/delete',
    PROMOTION_DELETE_FROM_CATEGORY = '/promotion/delete-from-category',
    PROMOTION_DELETE_FROM_PRODUCT = '/promotion/delete-from-product',
    PROMOTION_GET_PRODUCTS_WITH_PROMO = '/promotion/get-products-with-promo',
    PROMOTION_GET_ALL_CAMPAIGNS = '/promotion/get-all-campaigns',
}

export enum SubscriptionRoutesEnum {
    SUBSCRIPTION_PLAN_GET_ALL_PLANS = '/subscription-plan/get-all-plans',
    SUBSCRIPTION_PLAN_INIT_SUBSCRIPTION_MODULE = '/subscription-plan/init-subscription-module',
    SUBSCRIPTION_PLAN_GET_ORGANISATION_SUBSCRIPTION_MODULES = '/subscription-plan/get-organisation-subscription-modules',
    SUBSCRIPTION_PLAN_GET_NEXT_INVOICE_DETAILS = '/subscription-plan/get-next-invoice-details',
    SUBSCRIPTION_PLAN_GET_ORGANISATION_INVOICES = '/subscription-plan/get-organisation-invoices',
    SUBSCRIPTION_PLAN_UPDATE_ORGANISATION_MODULES = '/subscription-plan/update-organisation-modules',
}
